import React from 'react';
import '../../../styles/labelling.scss';
import TickIcon from '../../../../../Icons/icons/TickIcon';

const colorList = [
  '#61BD4F',
  '#F2D600',
  '#F49715',
  '#EB5A46',
  '#C377E0',
  '#0250EC',
  '#00C2E0',
  '#51E898',
  '#FF78CB',
  '#344563',
];

const ColorSelector = ({ selectedColor, setSelectedColor }) => {
  return (
    <div className="sl-label-color-selector">
      <div className="sl-label-color-selector-header">Select a color</div>
      <div className="sl-label-color-container">
        {colorList.map((color) => (
          <div
            onClick={() => setSelectedColor(color)}
            className="sl-color-box "
            key={color}
            style={{ backgroundColor: color }}>
            {selectedColor === color && <TickIcon color="#ffff" width={30} height={30} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorSelector;
